import axios from "axios";

import * as actionTypes from "../actionTypes";
import {
  getAuthToken
} from "../../authConfig";

export const AppListStart = () => {
  return {
    type: actionTypes.APP_LIST_START
  }
}
export const AppListSuccess = (data) => {
  return {
    type: actionTypes.APP_LIST_COUNT,
    data: data
  };
};


export const AppListFail = (error) => {
  return {
    type: actionTypes.APP_LIST_ERROR,
    error: error
  };
};


export const AppListDetails = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      getAuthToken()
      dispatch(AppListStart())
      axios
      .get(`/api/apps/?is_global=true`)
      .then(response => {
          dispatch(AppListSuccess(response.data.data));
          return resolve();
      })
      .catch(err => {
          dispatch(AppListFail(err.response.data));
          return reject();
      });
      })
  }
};